import { render, staticRenderFns } from "./FaceSetting.vue?vue&type=template&id=7d2eccf0"
import script from "./FaceSetting.vue?vue&type=script&lang=js"
export * from "./FaceSetting.vue?vue&type=script&lang=js"
import style0 from "./FaceSetting.vue?vue&type=style&index=0&id=7d2eccf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports